import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CustomToastersService } from '../services';
import { ApiErrors, ApiErrorsMessage } from '@app/shared/enums';

@Injectable()
export class HttpErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private readonly customToasters: CustomToastersService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has('Skip-Interceptor')) {
      const headers = request.headers.delete('Skip-Interceptor');
      return next.handle(request.clone({ headers }));
    }

    return next.handle(request).pipe(
      tap({
        next: () => {},
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            const isGetCountersEndpoint = request.url.includes('get-counters');
            const errorTitle = error.status >= 500 ? 'Server Error' : 'Error Occurred';
            let overrideConfig = {};

            if (error.status === 500) {
              overrideConfig = {
                timeOut: 8000
              };
            }
            const errorMessage = this.getErrorMessage(error);
            if (!isGetCountersEndpoint && error.error.ErrorCode != ApiErrors.QuizInstanceNotStarted && error.error.ErrorCode !== ApiErrors.SuperUserSiteSwitchNotPermitted) {
              if (error.error.ErrorCode === ApiErrors.DuplicateEntry) {
                this.customToasters.customError('Duplicate entry', 'Save Failed');
              } else {
                this.customToasters.customError(errorMessage, errorTitle, overrideConfig);
              }
            }
          }
        }
      })
    );
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    let errorMessage = `Request Error ${error.status} - ${error.statusText}`;
    if (error.error) {
      errorMessage =
        ApiErrorsMessage[error.error.ErrorCode] ||
        error.error.Message ||
        error.error.Title ||
        ApiErrorsMessage[error.status] ||
        errorMessage;
    }

    const replaceMap = this.getVariablesMap(error);
    errorMessage = this.insertErrorVariables(errorMessage, replaceMap);

    return errorMessage;
  }

  private getVariablesMap(error: HttpErrorResponse): { [key: string]: any } {
    const replaceMap = {};

    if (error.error?.traceId) {
      replaceMap['TRACE_ID'] = error.error.traceId;
    }

    return replaceMap;
  }

  private insertErrorVariables(errorMessage: string, replaceMap: { [key: string]: any }): string {
    const objEntries = Object.entries(replaceMap);

    objEntries.forEach(([key, value]: [string, any]) => {
      errorMessage = errorMessage.replace(`{{${key}}}`, value);
    });

    return errorMessage;
  }
}
